import { PARTNER_ONBOARDING_STATUSES, PartnerOnboardingEntityType, PartnerOnboardingStatus } from 'vopay';

/** The table's filters: owned by OnboardingTrackerPage, edited by OnboardingFilters. */
export type OnboardingFilterValues = {
  /** Empty means all three types (the API method then sends no `EntityType`). */
  entityTypes: PartnerOnboardingEntityType[];
  /** `''` means any onboarding status. */
  status: PartnerOnboardingStatus | '';
  /** `''` means no keyword. Matches name or ID on the backend. */
  keyword: string;
};

/**
 * Narrows a status to the onboarding set, e.g. `getOnboardingPipeline`'s `AccountWorkflowStatus[]` or a
 * `?stage=` URL value, without a cast.
 */
export function isPartnerOnboardingStatus(value: string | null): value is PartnerOnboardingStatus {
  return PARTNER_ONBOARDING_STATUSES.some((status) => status === value);
}
